<div class="select-seed-date">
  <mat-toolbar class="select-seed-date-header mat-elevation-z4 custom-toolbar">
    <mat-toolbar-row style="padding:0 5px;">
      <button mat-icon-button class="toolbar-title" aria-label="back clicked" (click)="backClicked()">
        <mat-icon class="volume-icon">arrow_back</mat-icon>
      </button>
      <div style="padding:8px 0 0 10px; flex:1;">
        <div class="mat-title toolbar-title" style="margin-bottom:2px;">Select Seed Date</div>
      </div>
      <button mat-icon-button class="toolbar-title" aria-label="read text" (click)="volumeClicked()">
        <mat-icon>volume_up</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="select-date-container">
    <img mat-card-image class="cardImg" src="/assets/select-seed.png" alt="select seed date" />
    <label class="label">Select a seed date</label>
    <mat-form-field class="datePicker" appearance="fill">
      <input matInput [matDatepicker]="picker"[max]="maxDate" [(ngModel)]="userSelectiondate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #picker></mat-datepicker>
    </mat-form-field>
    <div class="dateAgo">
      {{userSelectiondate | dateAgo}}
    </div>
    <button mat-flat-button class="c-btn" (click)="clickConfirm(userSelectiondate)">CONFIRM</button>
  </div>
</div>
